export default __webpack_public_path__ + "static/media/EM1750.34I-41298_-24639_0.99ba8236.jpg";